import { render, staticRenderFns } from "./AccessSettings.vue?vue&type=template&id=b9a06dd8&scoped=true"
import script from "./AccessSettings.vue?vue&type=script&lang=js"
export * from "./AccessSettings.vue?vue&type=script&lang=js"
import style0 from "./AccessSettings.vue?vue&type=style&index=0&id=b9a06dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a06dd8",
  null
  
)

export default component.exports